import React from "react";
import { useEffect, useState, useRef, useMemo } from "react";
import "./propertiesagency.css";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { PropertySetPrimaryUrl, SearchContacts, ContactDetailsApi, addmulitpletenants, addtenantfromcontact, updatetenantfoliodetails } from "../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import TextBox from "../../../src/input-components/textbox";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import { BiEnvelope, BiPhone } from "react-icons/bi";
import Collapse from "../../../src/input-components/collapse";
import { Checkbox } from "primereact/checkbox";
import { Select, Spin } from "antd";
import debounce from "lodash/debounce";
import { addParametersForProfiles, dynamicUrl } from "../../../Utilities/profileManagement";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";

const initialValues = {
  tenants: [
    {
      fname: "",
      lname: "",
      email: "",
      mobileNumber: "",
      contactUniqueId: "",
      isPrimary: true,
    },
  ],
};


const TenantPropertyAgency = ({ onDataRecive, handleparentsuccess, getDetails, handleCurrentPage, cancel, tenantId, tabChange,manageTenant ,onTenantFormSubmit}) => {
  console.log(getDetails,'getDetails')
  const [userId, setUserId] = useState("");
  const [agentId, setAgentId] = useState("");
  const navigate = useNavigate();
  const [agencyId, setAgencyId] = useState("");
  const [fetching, setFetching] = useState(false);
  const [option, setOption] = useState([]);
  const fetchRef = useRef(0);
  const [contactId, setContactId] = useState(0);
  const { showSpinner, hideSpinner } = useSpinnerContext();
  var url = new URL(window.location.href);
  var propertyUId = url.searchParams.get("propertyUID");
const ToastRef = useRef();
  useEffect(() => {
    const retrieveData = async () => {
      try {
        const userData = GetCookie("@UserData");
        if (userData) {
          const parsedData = JSON.parse(userData);
          setUserId(parsedData.userId);
          setAgentId(parsedData.agentId);
          setAgencyId(parsedData.agencyID);
        }
      } catch (error) {
        console.error("Error retrieving data from AsyncStorage:", error);
      }
    };
    retrieveData();
  }, [userId]);


  useEffect(() => {
    if (getDetails && getDetails.tenantDetails?.length > 0) {
      debugger
      const mappedTenants = getDetails.tenantDetails.map((tenant) => {
        // Also push to a `selectedContactOptions` array if you're tracking that per tenant
        return {
          fname: tenant.tenantFname || "",
          lname: tenant.tenantLname || "",
          email: tenant.tenantEmail || "",
          mobileNumber: tenant.tenantMobile || "",
          contactUniqueId: tenant.contactUId || "",
          tenantId: tenant.tenantId || 0,
          contactOption: {
            label: `${tenant.tenantFname} ${tenant.tenantLname}`,
            value: tenant.contactId,
            uid: tenant.contactUId
          },
          tenancyType: tenant.tenantFolioDetails.tenancyType,
          rentInvoiceStatus: tenant.tenantFolioDetails.rentInvoice,
          invoiceDaysInAdvance: tenant.tenantFolioDetails.invoiceDaysInAdvance,
          isPrimary: tenant.primaryTenant
        };
      });

      // Set form values
      setValues({ tenants: mappedTenants });

      // Optional: if you're managing a separate selectedContacts state per tenant
      // setSelectedValues(mappedTenants.map(t => t.contactOption))
    }
  }, [getDetails]);

//   useEffect(() => {
//   if (tenantId && getDetails?.tenantDetails?.length > 0) {
//     const tenantData = getDetails.tenantDetails.find(t => t.tenantId === tenantId);
//     if (tenantData) {
//       setValues({
//         tenants: [{
//           fname: tenantData.tenantFname || "",
//           lname: tenantData.tenantLname || "",
//           email: tenantData.tenantEmail || "",
//           mobileNumber: tenantData.tenantMobile || "",
//           contactUniqueId: tenantData.contactUId || "",
//           tenantId: tenantData.tenantId || 0,
//           contactOption: {
//             label: `${tenantData.tenantFname} ${tenantData.tenantLname}`,
//             value: tenantData.contactId,
//             uid: tenantData.contactUId
//           }
//         }]
//       });
//     }
//   } else {
//     setValues({
//       tenants: [{
//         fname: "",
//         lname: "",
//         email: "",
//         mobileNumber: "",
//         contactUniqueId: "",
//         tenantId: 0,
//         contactOption: undefined
//       }]
//     });
//   }
// }, [tenantId, getDetails]);


  const {
    errors,
    values,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: initialValues,
    //validationSchema: TenantContactSchema,
    onSubmit: (values) => {
      handleFinalSubmit();
    }
  });


 const handleFinalSubmit = () => {
  const tenants = values.tenants.map((tenant) => {
    const isExistingContactSelected = tenant.contactOption?.value;
    const isUpdatingExistingTenant = tenant.tenantId > 0;

    const baseTenant = {
      PropertyId: getDetails.propertyId,
      PrimaryTenant: tenant.isPrimary || false,
      TenantFname: tenant.fname,
      TenantLname: tenant.lname,
      TenantEmail: tenant.email,
      TenantMobile: tenant.mobileNumber,
    };

    if (isUpdatingExistingTenant) {
      return {
        ...baseTenant,
        TenantId: tenant.tenantId,
      };
    }

    if (isExistingContactSelected) {
      return {
        ...baseTenant,
        TenantId: 0,
        ContactId: tenant.contactOption.value,
        TenantAddress: tenant.address || "",
      };
    }

    return {
      ...baseTenant,
      TenantId: 0,
      ContactId: 0,
      TenantAddress: tenant.address || "",
    };
  });

  const payload = {
    PropertyId: getDetails.propertyId,
    AgencyId: agencyId,
    AgentId: agentId,
    Tenants: tenants,
    ...(manageTenant && { NewTenant: true }),
  };

if (manageTenant && typeof onTenantFormSubmit === "function") {
  const validationErrors = [];

  values.tenants.forEach((tenant, idx) => {
    if (!tenant.fname?.trim()) {
      validationErrors.push(`Tenant ${idx + 1}: First name is required.`);
    }
    if (!tenant.email?.trim()) {
      validationErrors.push(`Tenant ${idx + 1}: Email is required.`);
    }
    if (!tenant.mobileNumber?.trim()) {
      validationErrors.push(`Tenant ${idx + 1}: Mobile number is required.`);
    }
  });

  const hasPrimary = values.tenants.some((t) => t.isPrimary);
  if (!hasPrimary) {
    validationErrors.push("At least one tenant must be set as primary.");
  }

  if (validationErrors.length > 0) {
    ToastRef.current.notify(["error", validationErrors.join(" ")]);
    return;
  }

  onTenantFormSubmit(payload);
  return;
}


  makeRequestWithSpinner(showSpinner, hideSpinner, addmulitpletenants, "post", payload)
    .then((returnData) => {
      if (returnData.status === ActionStatus.Successfull) {
        tabChange(propertyUId, "Rent Details",);
         ToastRef.current.notify(["success", returnData.message]);
      } else {
         ToastRef.current.notify(["error", returnData.message]);
      }
    })
    .catch((error) => {
       ToastRef.current.notify(["error", returnData.message]);
    });
};


  useEffect(() => {
    agentUIDRef.current = agentId;
  }, [agentId]);

  const agentUIDRef = useRef(agentId);

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      const agentId = agentUIDRef.current;
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOption([]);
      setFetching(true);
      const baseUrl = SearchContacts;
      let data = {
        Search: value,
        RecordsPerPage: 10,
        PageNo: 1,
        AgentID: agentId,
      };
      data = addParametersForProfiles(data);
      makeRequestWithSpinner(
        showSpinner,
        hideSpinner,
        baseUrl,
        "post",
        data,
        "",
        false
      )
        .then((response) => {
          if (response.status === 1) {
            let landingPageListData = response.list;
            const transformedData = landingPageListData.map((item) => ({
              value: item.id,
              label: item.name,
              uid: item.uid
            }));
            if (fetchId === fetchRef.current) {
              setOption(transformedData);
              setFetching(false);
            }
          } else {
            setFetching(false);
          }
        })
        .catch((error) => {
          setFetching(false);
        });
    };
    return debounce(loadOptions, 800);
  }, []);


  const handleSearchChange = (e, value, index) => {
    if (!value || value.length === 0) return;

    const selected = value[0]; // { label, value, uid }
    const uid = selected.uid;
    const contactId = selected.value;

    // Update the tenant at index
    const updatedTenants = [...values.tenants];
    updatedTenants[index] = {
      ...updatedTenants[index],
      contactOption: selected, // So the Select shows the correct value
      contactUniqueId: uid,
    };

    setFieldValue("tenants", updatedTenants);
    setContactId(contactId);
    GetContactDetails(uid, index); // Fetch details and update that tenant
  };


  const GetContactDetails = (contactUniqueId, index) => {
    const apiUrl = `${ContactDetailsApi}?contactUniqueId=${contactUniqueId}`;
    makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          const data = response.object;

          const updatedTenants = [...values.tenants];
          updatedTenants[index] = {
            ...updatedTenants[index],
            fname: data.firstName || "",
            lname: data.lastName || "",
            email: data.email || "",
            mobileNumber: data.mobileNumber || "",
            contactUniqueId: data.contactUniqueId || "",
            contactOption: {
              label: `${data.firstName || ""} ${data.lastName || ""}`.trim(),
              value: data.contactId,
              uid: data.contactUniqueId
            }
          };

          setFieldValue("tenants", updatedTenants);
        } else {
          handleparentsuccess(["warn", response.data.message]);
        }
      })
      .catch((error) => {
        handleparentsuccess(["error", error.message]);
      });
  };



const handleTenantChange = (index, field, value) => {
  const updatedTenants = [...values.tenants];

  if (field === "isPrimary") {
    if (!value) {
      const primaryCount = updatedTenants.filter((t) => t.isPrimary).length;
      if (primaryCount === 1) {
        handleparentsuccess(["error", "At least one tenant must be set as primary."]);
        return;
      }
    }

    updatedTenants.forEach((tenant, i) => {
      tenant.isPrimary = i === index ? value : false;
    });
  } else {
    updatedTenants[index][field] = value;
  }

  setFieldValue("tenants", updatedTenants);
};


  const handleDeleteTenant = (index) => {
    const updated = values.tenants.filter((_, i) => i !== index);
    setFieldValue("tenants", updated);
  };

  const handleAddTenant = () => {
    const newTenant = {
      fname: "",
      lname: "",
      email: "",
      mobileNumber: "",
      contactUniqueId: "",
      tenancyType: 0,
      rentInvoiceStatus: "",
      invoiceDaysInAdvance: ""
    };
    setFieldValue("tenants", [...values.tenants, newTenant]);
  };


  return (
    <div>
    <ToastAlert ref={ToastRef} />
      <form onSubmit={handleSubmit}>
        <div className="all-input">
          <div className="pddpn-group pd-address">

            {values.tenants.map((tenant, index) => (
              <Collapse
                id={`tenant-${index}`}
                title={`Tenant ${index + 1}`}
                data={
                  <div className="row contacts-group">
                    <div className="col-lg-6 col-sm-12">
                      <label className="s1">Contacts</label>
                      <Select
                        style={{ width: "100%", height: "40px" }}
                        placeholder="Search for contacts"
                        labelInValue
                        showSearch
                        filterOption={false}
                        onSearch={debounceFetcher}
                        notFoundContent={fetching ? <Spin size="small" /> : null}
                        options={option}
                        onChange={(label, value) =>
                          handleSearchChange(label, [value], index)
                        }
                        value={values.tenants[index]?.contactOption || undefined}
                        disabled={tenant.fname ? true : false}
                      />

                    </div>
                    <TextBox
                      isMandatory
                      label="First Name"
                      name={`tenants[${index}].fname`}
                      value={tenant.fname}
                      onChange={(e) =>
                        handleTenantChange(index, "fname", e.target.value)
                      }
                    />
                    <TextBox
                      label="Last Name"
                      name={`tenants[${index}].lname`}
                      value={tenant.lname}
                      onChange={(e) =>
                        handleTenantChange(index, "lname", e.target.value)
                      }
                    />
                    <TextBox
                      isMandatory
                      label="Mobile"
                      name={`tenants[${index}].mobileNumber`}
                      value={tenant.mobileNumber}
                      onChange={(e) =>
                        handleTenantChange(index, "mobileNumber", e.target.value)
                      }
                      icon={<BiPhone />}
                    />
                    <TextBox
                      isMandatory
                      label="Email"
                      name={`tenants[${index}].email`}
                      value={tenant.email}
                      onChange={(e) =>
                        handleTenantChange(index, "email", e.target.value)
                      }
                      icon={<BiEnvelope />}
                    />

                   

                    <div className="col-lg-12 mt-2 text-right">
                      {!tenant.isPrimary && ( // Ensure the delete button is not displayed for the first owner
                        <button
                          type="button"
                          className="btn"
                          style={{ background: "white", border: "1px solid gray", color: "gray" }}
                          onClick={() => handleDeleteTenant(index)}
                        >
                          <DeleteOutlined
                            style={{
                              fontSize: "16px",
                              cursor: "pointer",
                              marginRight: "5px",
                            }}
                            title="Delete Owner"
                          />
                          Delete Tenant
                        </button>
                      )}
                    </div>
 <div className="mt-3 col-lg-4 mb-3 d-flex align-items-center">
                      <Checkbox
                        checked={
                          values.tenants[index]
                            ? values.tenants[index].isPrimary
                            : false
                        }
                        onChange={(e) =>
                          handleTenantChange(
                            index,
                            "isPrimary",
                            e.target.checked
                          )
                        }
                      />

                      <label
                        className="ml-2"
                        htmlFor={`primary-owner-${index}`}
                      >
                        Set as primary
                      </label>
                    </div>

                  </div>
                }
              />
            ))}
            <div className="add-owner-btn1 mt-3" onClick={handleAddTenant}>
              <PlusOutlined className="plus-icon1" />
              <span className="span1">Add Another Tenant</span>
            </div>

          </div>
          <div className="property-details-buttons">
            <button
              className="pdb-cancel"
              type="reset"
              onClick={cancel}
            >
              Cancel
            </button>
            <button className="pdb-save-changes" type="submit">
              Save
            </button>
          </div>
        </div>
      </form>

    </div>
  );
};

export default TenantPropertyAgency;
